export class Disciplina {
  constructor({
    id = null,
    nome = null,
    tipoDisciplina = null,
    descricao = null,
    ementa = null
  }) {
    this.id = id;
    this.nome = nome;
    this.tipoDisciplina = tipoDisciplina;
    this.descricao = descricao;
    this.ementa = ementa;
  }
  static Build() {
    return new Disciplina({
      id: null,
      nome: null,
      tipoDisciplina: null,
      descricao: null,
      ementa: null
    });
  }
  format() {
    return {
      id: this.id,
      nome: this.nome,
      tipo: this.tipoDisciplina?.id,
      descricao: this.descricao,
      ementa: this.ementa,
    };
  }
}
